export const affiliateVarieties = [
  { label: "HOG Chapter", value: "1" },
  // { label: "Make-A-Wish", value: "2" },
];

export const affiliateClassifications = [
  { label: "Club", value: "1" },
  { label: "Charity", value: "2" },
];
